import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-height: calc(100vh - 252px - 120px);
  overflow-y: auto;
`;



// WEBPACK FOOTER //
// ./components/layout/UsersManager.js